export class CrosshairRenderer {
    render(ctx, options) {
        const { plotBounds, position, themeMode } = options;
        if (!position) {
            return;
        }
        const x = Math.max(plotBounds.left, Math.min(position.x, plotBounds.left + plotBounds.width));
        const y = Math.max(plotBounds.top, Math.min(position.y, plotBounds.top + plotBounds.height));
        const strokeColor = options.crosshairColor ?? (themeMode === "dark" ? "rgba(41,98,255,0.6)" : "rgba(41,98,255,0.5)");
        const crosshairWidth = 1;
        const dotOnly = options.mode === "dot";
        ctx.save();
        if (!dotOnly) {
            ctx.setLineDash([4, 4]);
            ctx.strokeStyle = strokeColor;
            ctx.lineWidth = crosshairWidth;
            ctx.beginPath();
            ctx.moveTo(x, plotBounds.top);
            ctx.lineTo(x, plotBounds.top + plotBounds.height);
            ctx.stroke();
            if (position.y >= plotBounds.top && position.y <= plotBounds.top + plotBounds.height) {
                ctx.beginPath();
                ctx.moveTo(plotBounds.left, y);
                ctx.lineTo(plotBounds.left + plotBounds.width, y);
                ctx.stroke();
                // T2-02: price label pill on right edge — with collision offset vs lastPriceY/beacon
                ctx.save();
                ctx.setLineDash([]);
                ctx.font = "11px Inter, sans-serif";
                ctx.textBaseline = "middle";
                const priceText = `${Math.round(y)}`;
                const pw = ctx.measureText(priceText).width + 8;
                const ph = 16;
                const px = plotBounds.left + plotBounds.width - pw;
                let py = Math.max(plotBounds.top, Math.min(y - ph / 2, plotBounds.top + plotBounds.height - ph));
                // Collision: if near beacon or lastPriceY, offset by 20px
                const beaconY = options.beacon?.y;
                const lastY = options.lastPriceY;
                if (beaconY !== undefined && Math.abs(py + ph / 2 - beaconY) < 18)
                    py = py < beaconY ? beaconY - ph - 4 : beaconY + 4;
                if (lastY !== undefined && Math.abs(py + ph / 2 - lastY) < 18)
                    py = py < lastY ? lastY - ph - 4 : lastY + 4;
                py = Math.max(plotBounds.top, Math.min(py, plotBounds.top + plotBounds.height - ph));
                ctx.fillStyle = strokeColor;
                ctx.beginPath();
                // @ts-ignore roundRect may not exist in all contexts
                if (ctx.roundRect)
                    ctx.roundRect(px, py, pw, ph, 2);
                else
                    ctx.rect(px, py, pw, ph);
                ctx.fill();
                ctx.fillStyle = "#ffffff";
                ctx.fillText(priceText, px + 4, py + ph / 2);
                ctx.restore();
            }
            // T2-dedup: time label only for bottom pane
            if (options.isBottomPane !== false) {
                ctx.save();
                ctx.setLineDash([]);
                ctx.font = "11px Inter, sans-serif";
                ctx.textBaseline = "middle";
                const timeText = `${Math.round(x)}`;
                const tw = ctx.measureText(timeText).width + 8;
                const th = 16;
                const tx = Math.max(plotBounds.left, Math.min(x - tw / 2, plotBounds.left + plotBounds.width - tw));
                const ty = plotBounds.top + plotBounds.height - th;
                ctx.fillStyle = strokeColor;
                ctx.beginPath();
                if (ctx.roundRect)
                    ctx.roundRect(tx, ty, tw, th, 2);
                else
                    ctx.rect(tx, ty, tw, th);
                ctx.fill();
                ctx.fillStyle = "#ffffff";
                ctx.fillText(timeText, tx + 4, ty + th / 2);
                ctx.restore();
            }
        } // end if (!dotOnly) — dot mode draws only the beacon below
        const beacon = options.beacon;
        if (beacon
            && beacon.x >= plotBounds.left && beacon.x <= plotBounds.left + plotBounds.width
            && beacon.y >= plotBounds.top && beacon.y <= plotBounds.top + plotBounds.height) {
            ctx.beginPath();
            ctx.arc(beacon.x, beacon.y, 4.5, 0, Math.PI * 2);
            ctx.fillStyle = "#ffffff";
            ctx.fill();
            ctx.beginPath();
            ctx.arc(beacon.x, beacon.y, 3, 0, Math.PI * 2);
            ctx.fillStyle = beacon.color;
            ctx.fill();
        }
        ctx.restore();
    }
}
